<app-checks [detail]="checksDetail" [checks]="checks" />
